export const TRACKING_TYPES = {
  BASIC: 'BASIC',
  ADVANCED: 'ADVANCED',
}
